import React from "react";
import { FeatureFlag } from "../../services";
import Utility from "../../utilities/Utility";
import DesignerSetting from "../../DesignerSetting";

class SettingsNav extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const inventoryEnabled = Utility.getCookieBool(FeatureFlag.inventory);
        const wizardConfig= Utility.getCookieBool(FeatureFlag.wizardConfig);
        return (
            <div id="settings_nav" className="row">
                {!Utility.getIsCommonModule(this.props.serialized) &&
                    <div className="col-md-8 col-md-offset-2">
                        <div className="title col-md-12">
                            <ul className="nav nav-tabs">
                                
                                <li className="settings-nav-button active">
                                    <a
                                        data-tip="The Application Basic tab sets a variety of rules for the application."
                                        data-toggle="tab"
                                        href="#basic"
                                    >
                                        {window.l.settings.application_basic}
                                    </a>
                                </li>
                                
                                <div className="break">&nbsp;</div>
                                <li className="settings-nav-button">
                                    <a
                                        data-tip="This tab allows you to specify properties for unit testing. Use the table in this tab to specify key-value-pairs that define properties for the application test instance."
                                        data-toggle="tab"
                                        href="#properties"
                                    >
                                        {window.l.settings.properties}
                                    </a>
                                </li>
                                
                                <div className="break">&nbsp;</div>
                                <li className="settings-nav-button">
                                    <a
                                        data-tip="The Locale tab allows you to translate prompts into other languages and select which languages are used in the application. You can also select a specific voice to articulate the prompts."
                                        data-toggle="tab"
                                        href="#locale"
                                    >
                                        {window.l.settings.locale}
                                    </a>
                                </li>

                                <div className="break">&nbsp;</div>
                                <li className="settings-nav-button">
                                    <a
                                        data-tip="Settings to use if HAU is disabled at any of the inputs in this application."
                                        data-toggle="tab"
                                        href="#hau"
                                    >
                                        HAU OPTIONAL
                                    </a>
                                </li>

                                <div className="break">&nbsp;</div>
                                <li className="settings-nav-button">
                                    <a
                                        data-tip='Filler (such as "Please hold on while I find that information" or the sound of typing) can be played to the caller when the application has to pause speaking while it accomplishes a task. Use this tab to configure filler prompts and typing sounds.'
                                        data-toggle="tab"
                                        href="#filler_prompts"
                                    >
                                        {window.l.settings.filler_prompts.title}
                                    </a>
                                </li>
                                <div className="break">&nbsp;</div>
                                <li className="settings-nav-button">
                                    <a
                                        data-tip="Some applications may include a DTMF code that allows callers to bypass the Virtual Assistant and contact a live agent directly. (This code might only be known to a subset of callers with special privileges or roles within the client organization.) Type the code in this tab."
                                        data-toggle="tab"
                                        href="#liveAgent"
                                    >
                                        {window.l.settings.dtmf_live_agent}
                                    </a>
                                </li>
                                
                                <div className="break">&nbsp;</div>
                                
                                {DesignerSetting.s.is_public === "false" &&
                                    <li className="settings-nav-button">
                                        <a
                                            data-tip="This tab provides a coding environment for developers to edit the CCXML code used to communicate between the voice application and the voice browser. This tab is usually hidden from non-developers."
                                            data-toggle="tab"
                                            href="#ccxml"
                                        >
                                            {window.l.settings.ccxml_editor}
                                        </a>
                                    </li>
                                }
                                
                                {/*TODO: Feature flag 894 begins*/}
                                {inventoryEnabled && <div className="break">&nbsp;</div>}
                                {inventoryEnabled && <li className="settings-nav-button">
                                    <a
                                        data-toggle="tab"
                                        href="#about"
                                    >
                                        About
                                    </a>
                                </li>}
                                {/*TODO: Feature flag 894 ends*/}
                            </ul>
                        </div>
                    </div>
                }
                {Utility.getIsCommonModule(this.props.serialized) &&
                    <div className="col-md-8 col-md-offset-2">
                        <div className="title col-md-12">
                            <ul className="nav nav-tabs">

                                <li className="settings-nav-button active">
                                    <a
                                        data-tip="The Application Basic tab sets a variety of rules for the common module."
                                        data-toggle="tab"
                                        href="#basic"
                                    >
                                        {window.l.settings.application_basic}
                                    </a>
                                </li>
                                <div className="break">&nbsp;</div>
                                <li className="settings-nav-button">
                                    <a
                                        data-tip="The Locale tab allows you to translate prompts into other languages and select which languages are used in the module. You can also select a specific voice to articulate the prompts."
                                        data-toggle="tab"
                                        href="#locale"
                                    >
                                        {this.props.labels.locale}
                                    </a>
                            </li>
                           { wizardConfig&& <div className="break">&nbsp;</div>}
                           { wizardConfig&&   <li className="settings-nav-button">
                                    <a
                                        data-toggle="tab"
                                        href="#wizardConfig">
                                        {"Import Config"}
                                    </a>
                                </li>}

                            </ul>
                        </div>
                    </div>
                }
       
            </div>
        );
    }

}

export default SettingsNav;
